import _ from 'lodash'
import Api from 'redux-apis'

import { commonChildApiProps } from './commonUtils'

export default class Keys extends Api {

  static INITIAL_STATE = {
    local: {},
    minions: {},
    minions_pre: {},
    minions_denied: {},
    minions_rejected: {}
  };

  constructor (saltApi) {
    //super(Keys.INITIAL_STATE)
    super({})

    Object.defineProperties(this, {
      ...commonChildApiProps(saltApi, this)
    })
    // Action handlers (reducers)
    this.setHandler('SET_KEYS', (state, action) => action.payload)
  }

  getKeys(mid) {
    let wantAllFingerprints = mid === '*'
    if (wantAllFingerprints) mid = ''
    return this
      .aio.get(`/keys/${ mid ? mid : ''}`)
      .then(res => res.data.return)
      .then(res => {
        if (wantAllFingerprints) {
          let uniqIds = _.uniq(
            res.minions||[], res.minions_pre||[], res.minions_denied||[], res.minions_rejected||[]
          )
          // console.log('uniqIds: ', uniqIds, res)
          return Promise.all(
            _.map(uniqIds, mid => {
              return this.aio.get(`/keys/${ mid }`).then(res => res.data.return)
            })
          ).then(results => {
            res = _.chain(res).map((v, k) => {
              return k === 'local' ? [k, v] : [k, {}]
            }).fromPairs().value()
            // console.log('P.all: ', results)
            _.forEach(results, r => {
              _.merge(res, r)
            })
            // console.log('P.all: merged ', res)
            return res
          })
        }
        if (mid) return res
        return _
          .chain(res || {})
          .map((v, k) => {
            if (k === 'local' || !_.isArray(v)) return [k, v]
            return [k, _
              .chain(v)
              .map(mid => { return [mid,] })
              .fromPairs()
              .value()]
          })
          .fromPairs()
          .value()
      })
      .then(res => {
        // console.log('getKeys', res)
        if (mid && !wantAllFingerprints)
          this.setStateChanges('SET_KEYS', _.merge(_.clone(this.getState() || {}), res))
          //this.dispatch(this.createAction('SET_KEYS', _.merge(_.clone(this.getState() || {}), res)))
        else
          this.setStateChanges('SET_KEYS', res)
          //this.dispatch(this.createAction('SET_KEYS', res))
        return res
      })
  }
  createNewKey() {}
}



// WEBPACK FOOTER //
// ./src/saltapi/Keys.js